import { useState, useEffect } from 'react';
import { Button } from '../ui/button';
import { Badge } from '../ui/badge';
import { ScrollArea } from '../ui/scroll-area';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogFooter } from '../ui/dialog';
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from '../ui/table';
import { toast } from 'sonner';
import api from '../../lib/api';
import { Loader2, FileUp, FileDown, Download } from 'lucide-react';

export function InventoryAuditLogDialog({ open, onOpenChange }) {
  const [auditLogs, setAuditLogs] = useState([]);
  const [loadingAudit, setLoadingAudit] = useState(false);

  useEffect(() => {
    if (!open) return;

    const loadAuditLog = async () => {
      setLoadingAudit(true);
      try {
        const response = await api.get('/inventory/excel/audit-log?limit=30');
        setAuditLogs(response.data);
      } catch (error) {
        toast.error('Errore nel caricamento log');
      } finally {
        setLoadingAudit(false);
      }
    };

    loadAuditLog();
  }, [open]);

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-3xl max-h-[80vh]">
        <DialogHeader>
          <DialogTitle>Log Operazioni Import/Export Inventario</DialogTitle>
          <DialogDescription>
            Storico delle operazioni massive sull'inventario
          </DialogDescription>
        </DialogHeader>

        {loadingAudit ? (
          <div className="flex justify-center py-8">
            <Loader2 className="h-8 w-8 animate-spin text-primary" />
          </div>
        ) : (
          <ScrollArea className="h-96">
            <Table>
              <TableHeader>
                <TableRow>
                  <TableHead>Data</TableHead>
                  <TableHead>Operazione</TableHead>
                  <TableHead>Utente</TableHead>
                  <TableHead>Dettagli</TableHead>
                  <TableHead>Stato</TableHead>
                </TableRow>
              </TableHeader>
              <TableBody>
                {auditLogs.map((log) => (
                  <TableRow key={log.id}>
                    <TableCell className="text-sm">
                      {new Date(log.timestamp).toLocaleString('it-IT')}
                    </TableCell>
                    <TableCell>
                      <Badge variant="outline">
                        {log.operation === 'import' && <FileUp className="h-3 w-3 mr-1" />}
                        {log.operation === 'export' && <FileDown className="h-3 w-3 mr-1" />}
                        {log.operation === 'template_download' && <Download className="h-3 w-3 mr-1" />}
                        {log.operation}
                      </Badge>
                    </TableCell>
                    <TableCell className="text-sm">{log.user_name}</TableCell>
                    <TableCell className="text-sm">
                      {log.items_created > 0 && <span className="text-emerald-600">+{log.items_created} </span>}
                      {log.items_updated > 0 && <span className="text-blue-600">~{log.items_updated} </span>}
                      {log.items_dismissed > 0 && <span className="text-orange-600">-{log.items_dismissed}</span>}
                      {log.items_exported > 0 && <span>{log.items_exported} esportati</span>}
                      {log.operation === 'template_download' && <span>-</span>}
                    </TableCell>
                    <TableCell>
                      <Badge
                        variant="outline"
                        className={
                          log.status === 'success' ? 'bg-emerald-100 text-emerald-700' :
                          log.status === 'partial' ? 'bg-amber-100 text-amber-700' :
                          'bg-red-100 text-red-700'
                        }
                      >
                        {log.status}
                      </Badge>
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </ScrollArea>
        )}

        <DialogFooter>
          <Button variant="outline" onClick={() => onOpenChange(false)}>
            Chiudi
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
